import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import { ToastContainer, toast } from 'react-toastify';
import { Modal } from "react-bootstrap";
import { jobSectorInvertList } from "../../../services/JobTypeAndSectorGlobalList";

const Dashboard = (props) => {
  const [show, setShow] = useState(false);
  let users_category = localStorage.getItem("users_category");
  let user_type = localStorage.getItem("user_job_type");

  const [usersCategory, setUsersCategory] = useState(users_category);
  const [userType, setUserType] = useState(user_type);

  // console.log("This Users Category :=> "+usersCategory);
  let dashboards = [
    {
      name: "My Profile",
      link: "/job-profile",
      icon: "fa fa-user",
      className: "blue",
    },
    {
      name: "Submit Timesheet",
      link: "/timesheet",
      icon: "fa fa-calendar",
      className: "yellow",
    },
    // {
    //   name: "Apply For Holiday",
    //   link: "/holiday",
    //   icon:"fa fa-calendar-times-o",
    //   className:'blue'
    // },
    {
      name: "My Availability",
      link: "/availability",
      //link: "/dashboard",
      icon: "fa fa-calendar-check-o",
      className: "red",
    },
    // {
    //   name: "My Payroll",
    //   link: "/dashboard",
    //   icon: "fa fa-address-card-o",
    //   className: "green",
    // },
    {
      name: "My Assignments",
      link: "/my-assignments",
      icon: "fa fa-sticky-note-o",
      className: "green",
    },
    {
      name: "Jobs Applied",
      link: "/jobs-applied",
      icon: "fa fa-briefcase",
      className: "yellow",
    },
    // {
    //   name: "Jobs Available",
    //   link: "/dashboard",
    //   icon: "fa fa-bullhorn",
    //   className: "green",
    // },
  ];
  dashboards =
    usersCategory && jobSectorInvertList[usersCategory] === "home care"
      ? [
          ...dashboards,
          {
            name: "Daily Logs",
            link: "/daily-logs",
            icon: "fa fa-comment-o",
            className: "blue",
          },
          {
            name: "Service Users",
            link: "/service-users",
            icon: "fa fa-heartbeat",
            className: "green",
          },
        ]
      : [
          ...dashboards,
          {
            name: "Service Users",
            link: "/service-users",
            icon: "fa fa-heartbeat",
            className: "blue",
          },
        ];

  if (userType !== "permanentrequirement" && (usersCategory === "home care" || usersCategory === "home_care" || usersCategory === "Home Care")) {
    dashboards = [
      ...dashboards,
      {
        name: "Shift Attendance",
        link: "/shift-attendance",
        icon: "fa fa-tachometer",
        className:
          usersCategory && jobSectorInvertList[usersCategory] === "home care"
            ? "red"
            : "green",
      },
    ];
  }
  // const notify = () => toast("Coming Soon!", { autoClose: 3000 });
  // console.log(show)

  useEffect(() => {
    if (users_category) {
      setUsersCategory(users_category);
    }
    if (user_type) {
      setUserType(user_type);
    }
  }, [user_type, users_category]);

  const handleLink = (e, link) => {
    // e.preventDefault();
    let dash = "/dashboard";
    console.log(dash);
    if (link === dash) {
      console.log("hii");
      setShow(true);
      // notify()
      // console.log(show)
    }
  };
  const handleClose = () => setShow(false);
  return (
    <React.Fragment>
      <div className="profile-modal">
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Coming Soon!</Modal.Title>
          </Modal.Header>
          {/* <Modal.Body></Modal.Body> */}
        </Modal>
      </div>

      <div className="job-categories bg-white">
        <div className="container">
          <div className="row">
            {dashboards.map((dashboard, key) => (
               <React.Fragment key={dashboard.link}>
                {dashboard.link !== "/dashboard" && (
                  <a
                    href={dashboard.link}
                    onClick={(e) => handleLink(e, dashboard.link)}
                
                    className="col-lg-3 col-md-6 col-sm-6"
                  >
                    <div className={"icon-bx-wraper " + dashboard.className}>
                      <div className="icon-content">
                        <div className="icon-md text-primary m-b20">
                          <i className={dashboard.icon}></i>
                        </div>
                        <p className="m-a0">{dashboard.name}</p>
                        <div className="rotate-icon">
                          <i className={dashboard.icon}></i>
                        </div>
                      </div>
                    </div>
                  </a>
                )}

                {dashboard.link === "/dashboard" && (
                  <Link
                    to={dashboard.link}
                    onClick={(e) => handleLink(e, dashboard.link)}
                    key={key}
                    className="col-lg-3 col-md-6 col-sm-6"
                  >
                    <div className={"icon-bx-wraper " + dashboard.className}>
                      <div className="icon-content">
                        <div className="icon-md text-primary m-b20">
                          <i className={dashboard.icon}></i>
                        </div>
                        <p className="m-a0">{dashboard.name}</p>
                        <div className="rotate-icon">
                          <i className={dashboard.icon}></i>
                        </div>
                      </div>
                    </div>
                  </Link>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
